<div class="cpcontent">
    <h2 style="display:inline-block;margin-right:20px">Activities</h2>
    <label for="dateInput">From: </label>
    <input style="display:inline-block;max-width:150px;margin-left:20px;margin-right:20px" class="form-control" type="date" id="dateInput" name="dateInput" [(ngModel)]="strselectedDate">
    <button class="btn btn-primary btn-sm" (click)="getData()">Submit</button>
    <br><br>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>Organization</th>
                <th>Logins</th>
                <th>Scenario Updates</th>
                <th>GPS Records</th>
                <th>Beacon Records</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let o of orgs">
                <td class="link" (click)="showModal(o)">{{o.name}}</td>
                <td [style.background-color]="o.logins > 0 ? '#cbf1cb' : 'white'">{{o.logins}}</td>
                <td [style.background-color]="o.scenarioupdates > 0 ? '#cbf1cb' : 'white'">{{o.scenarioupdates}}</td>
                <td [style.background-color]="o.gps > 0 ? 'lightgreen' : 'white'">{{o.gps}}</td>
                <td [style.background-color]="o.beacons > 0 ? 'lightgreen' : 'white'">{{o.beacons}}</td>
            </tr>
        </tbody>
    </table>
    <br>
    <hr>
    <div class="row">
        <div class="col-md-3">
            <div style="width:100%">
                <h5>Logins</h5>
                <table class="table table-bordered" style="table-layout:fixed;word-break: break-all ">
                    <thead>
                        <tr>
                            <th style="width:20%">Id</th>
                            <th>Date</th>
                            <th>User</th>
                            <th>Organization</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let lu of loginlogs">
                            <td>{{lu.id}}</td>
                            <td>{{lu.dateCreated | date: "shortDate"}}</td>
                            <td>{{lu.description}}</td>
                            <td>{{lu.orgname}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-md-3">
            <h5>Scenario Updates</h5>
            <table class="table table-bordered" style="table-layout:fixed;word-break: break-all ">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Date</th>
                        <th>User</th>
                        <th>ScenarioId</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let lu of scenariologs">
                        <td>{{lu.id}}</td>
                        <td>{{lu.dateCreated | date: "shortDate"}}</td>
                        <td>{{lu.username}}</td>
                        <td>{{lu.scenarioid}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-3">
            <h5>Beacon Records</h5>
            <table class="table table-bordered" style="table-layout:fixed;word-break: break-all ">
                <thead>
                    <tr>
                        <th>Scenario Id</th>
                        <th>Scenario</th>
                        <th>Organization

                        </th>
                        <th>Last Date
                        </th>
                        <th>Count
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let o of overview">
                        <td>{{o.scenarioId}}</td>
                        <td>{{lookup(o.scenarioId,scenarios)}}</td>
                        <td>{{o.organizationname}}</td>
                        <td>{{o.lastDate | date: 'shortDate'}}
                        </td>
                        <td>{{o.count}}
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-3">
            <h5>GPS Records</h5>
            <table class="table table-bordered" style="table-layout:fixed;word-break: break-all ">
                <thead>
                    <tr>

                        <th>Scenario</th>
                        <th>Organization</th>
                        <th>Count</th>
                        <th>Last Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let b of overviewgps">

                        <td>{{b.scenarioname}}</td>
                        <td>{{b.organizationname}}</td>
                        <td>{{b.count}}</td>
                        <td>{{b.lastDate | date: 'shortDate'}}</td>

                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- Modal -------------------------------------------------------------------------------------->
<div *ngIf="showModalWindow" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:600px">
        <h5>{{org.name}} (last activites)</h5>
        <div *ngIf="org.beaconLogCount > 0">
            <b>Beacon records</b>
            {{this.org.beaconLogCount}}, Last Date:{{this.org.lastBeaconLogDate | date: 'shortDate'}}
            <br>
        </div>
        <div *ngIf="org.gpsLogCount > 0">
             <b>GPS records</b>
            {{this.org.gpsLogCount}}, Last Date:{{this.org.lastGpsLogDate | date: 'shortDate'}}
            <br>
        </div>
        <div *ngIf="org.lastLoginDate !=''">
            <b>Last Login</b>
           {{this.org.lastLoginDate | date: 'shortDate'}}
           <br>
       </div>
        <br>
        <span>.</span>
        <button class="btn btn-secondary" style="float:right" (click)="showModalWindow = false">Close Modal</button>
    </div>
</div>